'use strict';

const APIError = require('../APIError');

/**
 * @class
 * @hideconstructor
 * @extends APIError
 * @memberof HomeyAPI
 */
class HomeyAPIError extends APIError {

  constructor({
    error,
    error_description = null,
    stack = null,
  }, statusCode) {
    super(error_description || error, statusCode);

    /**
     * Error description
     * @type {string}
     */
    this.description = error_description;

    /**
     * Error stacktrace
     * @type {string}
     * @private
     */
    this.stack = stack;
  }

}

module.exports = HomeyAPIError;
